import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { history } from 'Route';

const PromotionDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Promotion/Promotion.dispatcher'
);

const NoMatchDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/NoMatch/NoMatch.dispatcher'
);

import Promotion from './Promotion.component';

export const mapStateToProps = state => ({
    promotion: state.PromotionReducer.promotion,
    isLoading: state.PromotionReducer.isLoading
});

export const mapDispatchToProps = dispatch => ({
    requestPromotion: (options) => PromotionDispatcher.then(
        ({ default: dispatcher }) => dispatcher.handleData(dispatch, options)
    ),
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName))
});

export class PromotionContainer extends PureComponent {
    componentDidMount() {
        const { toggleBreadcrumbs, promotion, isLoading } = this.props;

        if (!isLoading && !promotion ) {
            history.push('/promo');
        }

        toggleBreadcrumbs(false);

        this.updateMeta(__('Promotion'));
        this.updateHeaderState(__('Promotion'));
        this._requestPromotion();
    }

    componentDidUpdate(prevProps) {
        const { slug, promotion, isLoading } = this.props;
        const { slug: prevSlug } = prevProps;

        if (!isLoading && !promotion) {
            history.push('/promo');
        }

        if (promotion?.hero?.title) {
            this.updateMeta(promotion.hero.title);
        }

        if (slug !== prevSlug) {
            let promoTitle = null;

            if (promotion && promotion.hero) {
                promoTitle = promotion.hero.title;
            }

            this.updateMeta(promoTitle || __('Promotion'));
            this.updateHeaderState(promoTitle || __('Promotion'));
            this._requestPromotion();
        }
    }

    updateMeta(title) {
        const { updateMeta } = this.props;
        const backgroundImage = this.props.promotion?.hero?.background_image || '';

        updateMeta({
            title,
            canonical_url: location.href,
            og_image: backgroundImage
        });
    }

    updateHeaderState(title) {
        const { setHeaderState } = this.props;

        setHeaderState({
            name: CMS_PAGE,
            title: title,
            onBackClick: () => history.goBack()
        });
    }

    _requestPromotion() {
        const { slug, requestPromotion } = this.props;

        const options = {
            slug
        };

        requestPromotion(options);
    }

    render() {
        const { isLoading, promotion } = this.props;

        if (!isLoading && !promotion) {
            return null;
        }

        return <Promotion promotion={ promotion } isLoading={ isLoading } />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PromotionContainer);
